const filtersHu = {
    "all_guests": "Teljes vendégadatbázis",
    "subscribed_guests": "Hírlevélre feliratkozott vendégek",
    "not_subscribed_guests": "Nem adott marketing hozzájárulást",
    "last_reservation": "Utolsó foglalás",
    "last_monthly_filters": {
        "-1": "Bármikor",
        "1": "Előző 1 hónap",
        "3": "Előző 3 hónap",
        "6": "Előző 6 hónap",
        "12": "Előző 12 hónap",
        "custom": "Egyedi időszak",
    },
    "custom_period": "Egyedi időszak",
    "pick_both_dates": "Válaszd ki az időszak kezdetét és végét is.",
    "visit_count": "Látogatások száma",
    "visit_count_value": "Látogatásszám",
    "visit_count_operators": {
        "any": "Mindegy",
        "eq": "Pontosan",
        "gte": "Legalább",
        "lte": "Legfeljebb",
        "gt": "Több mint",
        "lt": "Kevesebb mint",
    },
}

export default filtersHu;
